import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=82ca56b0&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=82ca56b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ca56b0",
  null
  
)

export default component.exports